/**
 * DHHP UI Component for Button
 */
import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
@Component({
  selector: 'dhhp-button',
  templateUrl: './dhhp-button.component.html',
  styleUrls: []
})
export class DhhpButtonComponent implements OnInit, AfterViewInit {
  @Input() color: string;
  @Input() type: string;
  @Input() value: string;
  @Input() class: string;
  @Input() disabled: boolean;
  /**
   * Analytics Properties
   */
  @Input() indexable: boolean = false;
  @Input() extendible: boolean = false;
  @Input() localizable: boolean = false;
  @Input() filterable: boolean = false;
  @Input() searchable: boolean = false;
  @Input() sortable: boolean = false;
  @Input() analyzable: boolean = false;
  @Input() displayable: boolean = false;
  @Input() auditable: boolean = false;
  @Input() loggable: boolean = false;
  @ViewChild("refBut", { read: ElementRef }) refBut: ElementRef;
  constructor(private renderer: Renderer2) {
  }
  ngOnInit() {
    if (this.type == undefined) {
      this.type = 'common'
    }
    if (this.value == undefined) {
      this.value = ""
    }
    if (this.class == undefined) {
      this.class = ""
    }
  }
  analyticProperties() {
    this.renderer.setAttribute(this.refBut.nativeElement, 'indexable', this.getAnalyticValue(this.indexable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'extendible', this.getAnalyticValue(this.extendible));
    this.renderer.setAttribute(this.refBut.nativeElement, 'localizable', this.getAnalyticValue(this.localizable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'filterable', this.getAnalyticValue(this.filterable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'searchable', this.getAnalyticValue(this.searchable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'sortable', this.getAnalyticValue(this.sortable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'analyzable', this.getAnalyticValue(this.analyzable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'displayable', this.getAnalyticValue(this.displayable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'auditable', this.getAnalyticValue(this.auditable));
    this.renderer.setAttribute(this.refBut.nativeElement, 'loggable', this.getAnalyticValue(this.loggable));
  }
  getAnalyticValue(value: boolean): any {
    return value ? true : false;
  }
  ngAfterViewInit(): void {
    if(this.type != 'icon')
    this.renderer.setProperty(this.refBut.nativeElement.children[0], 'innerHTML', this.value);
    if (this.disabled == true) {
      this.renderer.setAttribute(this.refBut.nativeElement, 'disabled', "true");
    }
    this.analyticProperties();
    switch (this.color) {
      case 'primary':
        this.class = this.class + ' mat-primary';
        break;
      case 'accent':
        this.class = this.class + ' mat-accent';
        break;
      case 'warn':
        this.class = this.class + ' mat-warn';
        break;
    }
    switch (this.type) {
      case 'raised':
        this.class = this.class + ' mat-raised-button';
        break;
      case 'stroked':
        this.class = this.class + ' mat-stroked-button';
        break;
      case 'flat':
        this.class = this.class + ' mat-flat-button';
        break;
      case 'fab':
        this.class = this.class + ' mat-fab';
        break;
      case 'icon':
        this.class = this.class + ' mat-icon-button';
        break;
      case 'item':
        this.class = this.class + ' mat-menu-item';
        break;
      case 'basic':
        this.class = this.class + ' mat-button';
        break;
    }
    
    this.renderer.setAttribute(this.refBut.nativeElement, 'class', this.class);
  }
}
